export const NATIVE_LANG_STORAGE_KEY = 'NativeLanguage';

export const languageSelectOptions = {
  en: { value: 'en', label: 'EN' },
  pt: { value: 'pt', label: 'PT' },
};
